import axios from "axios";
import uuid from "react-uuid";
import config from "../config.json";
import AWS from "aws-sdk";

// Save new expense to the server
export const saveUser = async (user) => {
  try {
    user.id = uuid();
    user.type = "appusers";
    console.log(user);
    await fetch(process.env.REACT_APP_SERVICE_URL + "/items", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(user),
    });
    console.log("user saved");
  } catch (err) {
    console.log("Error saving expense: ", err);
    throw err;
  } finally {
    return 200;
  }
};

export const EMAIL_API_URL =
  process.env.REACT_APP_EMAIL_URL ||
  process.env.REACT_APP_EAMIL_URL ||
  "https://yzcjrbt1x1.execute-api.us-east-1.amazonaws.com/sendemail";

export const sendEmail = async (data) => {
  console.log("from service call start", data);

  const payload = {
    ...data,
    sender: data.sender || process.env.REACT_APP_SENDEREMAIL || "Recipe AI <support@theuniquecreations.com>",
  };

  const isLocalDev =
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

  // In local development on localhost, attempt to use the local dev proxy if available
  if (isLocalDev) {
    try {
      const proxyRes = await fetch("/email-api/sendemail", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const contentType = proxyRes.headers.get("content-type") || "";
      if (proxyRes.ok && !contentType.includes("text/html")) {
        console.log("Email sent successfully via local dev proxy");
        return { success: true };
      }
    } catch (proxyErr) {
      console.warn("Local proxy unavailable, falling back to direct SES endpoint", proxyErr);
    }
  }

  // Direct AWS SES endpoint:
  // Using mode 'no-cors' with 'text/plain' ensures:
  // 1. Browser treats this as a W3C Simple Request
  // 2. Skips OPTIONS preflight entirely (eliminates CORS errors on all domains)
  // 3. Delivers payload directly to AWS Lambda / SES
  try {
    await fetch(EMAIL_API_URL, {
      method: "POST",
      mode: "no-cors",
      headers: { "Content-Type": "text/plain" },
      body: JSON.stringify(payload),
    });

    console.log("Email dispatched successfully via SES");
    return { success: true };
  } catch (err) {
    console.error("No-cors send failed, attempting standard fetch:", err);
    try {
      const directRes = await fetch(EMAIL_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (directRes.ok) {
        console.log("Email sent successfully via standard fetch");
        return { success: true };
      }
      return { error: `HTTP ${directRes.status}` };
    } catch (finalErr) {
      console.error("All email delivery attempts failed:", finalErr);
      return { error: finalErr.message || "Failed to send email" };
    }
  }
};

// Save new expense to the server
export const UpdateUser = async (user) => {
  try {
    user.id = user.id;
    user.type = "appusers";
    console.log(user);
    await fetch(process.env.REACT_APP_SERVICE_URL + "/items", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(user),
    });
    console.log("user updaed");
  } catch (err) {
    console.log("Error saving user: ", err);
    throw err;
  } finally {
    return 200;
  }
};
export const UpdateData = async (user) => {
  try {
    console.log(user);
    await fetch(process.env.REACT_APP_SERVICE_URL + "/items", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(user),
    });
    console.log("user updaed");
  } catch (err) {
    console.log("Error saving user: ", err);
    throw err;
  } finally {
    return 200;
  }
};
export const addData = async (data) => {
  try {
    console.log(data);
    await fetch(process.env.REACT_APP_SERVICE_URL + "/items", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    console.log("category saved");
  } catch (err) {
    console.log("Error saving category: ", err);
    throw err;
  } finally {
    return 200;
  }
};

export const onAddFriendService = async (user) => {
  try {
    user.id = uuid();
    user.type = "usersfriend";
    console.log(user);
    await fetch(process.env.REACT_APP_SERVICE_URL + "/items", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(user),
    });
    console.log("user and balance saved");
  } catch (err) {
    console.log("Error saving expense: ", err);
    throw err;
  } finally {
    return 200;
  }
};
export const addExpenseCategory = async (data) => {
  try {
    console.log(data);
    await fetch(process.env.REACT_APP_SERVICE_URL + "/items", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    console.log("category saved");
  } catch (err) {
    console.log("Error saving category: ", err);
    throw err;
  } finally {
    return 200;
  }
};
export const getExpenseCategory = async (email) => {
  try {
    console.log("Fetching data for email:", email);

    // Prepare the request body
    const requestBody = {
      column1: "email",
      value1: email,
      column2: "type",
      value2: "expense-category",
    };

    // Make a POST request to the Lambda endpoint
    const response = await fetch(process.env.REACT_APP_SERVICE_URL + "items/filter2column", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });

    // Parse and return the filtered data
    const data = await response.json();
    return data || []; // Return items or an empty array if no items found
  } catch (err) {
    console.log("Error getting users:", err);
    return []; // Return an empty array on error
  }
};

export const onUpdateFriendService = async (user) => {
  try {
    user.type = "usersfriend";
    console.log("onUpdateFriendService", user);
    await fetch(process.env.REACT_APP_SERVICE_URL + "/items", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(user),
    });
    console.log("user and balance updated");
  } catch (err) {
    console.log("Error saving expense: ", err);
    throw err;
  } finally {
    return 200;
  }
};
export const getDataFromServer = async (email) => {
  try {
    console.log("Fetching data for email:", email);

    // Prepare the request body
    const requestBody = {
      column1: "email",
      value1: email,
      column2: "type",
      value2: "usersfriend",
    };

    // Make a POST request to the Lambda endpoint
    const response = await fetch(process.env.REACT_APP_SERVICE_URL + "items/filter2column", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });

    // Parse and return the filtered data
    const data = await response.json();
    return data || []; // Return items or an empty array if no items found
  } catch (err) {
    console.log("Error getting users:", err);
    return []; // Return an empty array on error
  }
};
// personal expense
export const getPersonalExpense = async (email) => {
  try {
    console.log("Fetching personal expense data for email:", email);

    // Prepare the request body
    const requestBody = {
      column1: "email",
      value1: email,
      column2: "type",
      value2: "expense",
    };

    // Make a POST request to the Lambda endpoint
    const response = await fetch(process.env.REACT_APP_SERVICE_URL + "items/filter2column", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });

    const data = await response.json();
    const filteredData = data.filter((item) => item.expensetype === "personal");
    console.log("shared data", filteredData);
    return filteredData || [];
  } catch (err) {
    console.log("Error getting users:", err);
    return [];
  }
};
export const getSharedExpense = async (email) => {
  try {
    console.log("Fetching expense data shared it has shared email:", email);

    const requestBody = {
      column1: "sharedWith",
      value1: email,
      column2: "type",
      value2: "expense",
    };

    const response = await fetch(process.env.REACT_APP_SERVICE_URL + "items/filter2column", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });

    const data = await response.json();
    const filteredData = data.filter((item) => item.expensetype === "shared");
    console.log("shared data", filteredData);
    return filteredData || [];
  } catch (err) {
    console.log("Error getting users:", err);
    return [];
  }
};
export const getExpenseHistory = async (email) => {
  try {
    console.log("Fetching expense data for email:", email);

    // Prepare the request body
    const requestBody = {
      column1: "email",
      value1: email,
      column2: "type",
      value2: "expense",
    };

    // Make a POST request to the Lambda endpoint
    const response = await fetch(process.env.REACT_APP_SERVICE_URL + "items/filter2column", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });

    const data = await response.json();

    return data || [];
  } catch (err) {
    console.log("Error getting users:", err);
    return [];
  }
};
export const fetchUsers_old = async (email) => {
  try {
    console.log(email);
    const response = await fetch(process.env.REACT_APP_SERVICE_URL + "itemsbytype/appusers");
    ///items/{column}/{value}
    const data = await response.json();
    // Filter the user by email
    const user = data.find((user) => user.email === email);
    // Return the matched user or null if not found
    return user || null;
  } catch (err) {
    console.log("Error getting users: ", err);
    throw err; // Re-throw the error to handle it outside
  }
};

export const fetchUsers = async (email) => {
  try {
    console.log("Fetching user for email:", email);
    // Prepare the request body with filtering conditions
    const requestBody = {
      column1: "email",
      value1: email,
      column2: "type",
      value2: "appusers",
    };

    // Make a POST request to the Lambda endpoint
    const response = await fetch(process.env.REACT_APP_SERVICE_URL + "items/filter2column", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });
    // Parse the JSON response
    const data = await response.json();
    return data[0];
  } catch (err) {
    console.log("Error getting users:", err);
    throw err; // Re-throw the error for handling outside
  }
};
export const deleteUser = async (id) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_SERVICE_URL}/removeitem/${id}`, {
      method: "DELETE",
    });

    if (!response.ok) {
      throw new Error("Failed to delete user.");
    }
    console.log("User deleted successfully:", id);
    return; // Return the response data if needed
  } catch (err) {
    console.log("Error deleting user:", err);
    throw err; // Re-throw the error to handle it in the calling function
  }
};
export const getData = async (email, type) => {
  try {
    console.log("Fetching personal expense data for email:", email);

    // Prepare the request body
    const requestBody = {
      column1: "email",
      value1: email,
      column2: "type",
      value2: type,
    };

    // Make a POST request to the Lambda endpoint
    const response = await fetch(process.env.REACT_APP_SERVICE_URL + "items/filter2column", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });

    const data = await response.json();

    console.log(" data", data);
    return data || [];
  } catch (err) {
    console.log("Error getting users:", err);
    return [];
  }
};
export const getData_Any2Column = async (column1, value1, column2, value2) => {
  try {
    console.log("Fetching personal expense data for email:", value1);

    // Prepare the request body
    const requestBody = {
      column1: column1,
      value1: value1,
      column2: column2,
      value2: value2,
    };

    // Make a POST request to the Lambda endpoint
    const response = await fetch(process.env.REACT_APP_SERVICE_URL + "items/filter2column", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });

    const data = await response.json();

    console.log(" data", data);
    return data || [];
  } catch (err) {
    console.log("Error getting users:", err);
    return [];
  }
};
export const getItemsbyid = async (id) => {
  try {
    console.log("Fetching items by ID:", id);
    const url = `${process.env.REACT_APP_SERVICE_URL}/items/id/${id}`; // Ensure proper URL construction
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status} - ${response.statusText}`);
    }
    const data = await response.json();
    console.log("Fetched data:", data);
    return data || [];
  } catch (err) {
    console.error("Error fetching items by ID:", err);
    return [];
  }
};
export const deleteData = async (id) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_SERVICE_URL}/removeitem/${id}`, {
      method: "DELETE",
    });

    if (!response.ok) {
      throw new Error("Failed to delete user.");
    }
    console.log("data deleted successfully:", id);
    return; // Return the response data if needed
  } catch (err) {
    console.log("Error deleting user:", err);
    throw err; // Re-throw the error to handle it in the calling function
  }
};

export const getCurrency = (country) => {
  const countryCurrencyData = getCountryCurrency();
  const matched = countryCurrencyData.find((item) => item.country.toLowerCase() === country.toLowerCase());
  return matched ? matched.currency : "";
};
export const getCountryCurrency = () => {
  return [
    { country: "United States", currency: "$", currencyName: "Dollar", code: "USD" },
    { country: "India", currency: "₹", currencyName: "Rupees", code: "INR" },
    { country: "Canada", currency: "CA$", currencyName: "Canadian Dollar", code: "CAD" },
    { country: "Australia", currency: "A$", currencyName: "Australian Dollar", code: "AUD" },
    { country: "Uruguay", currency: "$U", currencyName: "Uruguayan Peso", code: "UYU" },
    { country: "United Kingdom", currency: "£", currencyName: "Pound Sterling", code: "GBP" },
    { country: "Ireland", currency: "€", currencyName: "Euro", code: "EUR" },
    { country: "Mexico", currency: "$", currencyName: "Mexican Peso", code: "MXN" },
    { country: "Brazil", currency: "R$", currencyName: "Brazilian Real", code: "BRL" },
  ];
};
export const getCurrencyName = (currency) => {
  const countryCurrencyData = getCountryCurrency();
  const matched = countryCurrencyData.find((item) => item.currency === currency);
  return matched ? matched.currencyName : "Unknown";
};
export const getItemsbyType = async (type) => {
  try {
    console.log(type);
    const response = await fetch(process.env.REACT_APP_SERVICE_URL + "itemsbytype/" + type);
    const data = await response.json();
    return data || null;
  } catch (err) {
    console.log("Error getting users: ", err);
    throw err;
  }
};
export const fetchRecipe = async (ingredients, cuisine) => {
  try {
    const response = await fetch(process.env.REACT_APP_AI_SERVICE_URL + "recepie-ai", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ingredients: ingredients,
        cuisine: cuisine,
      }),
    });

    if (!response) {
      throw new Error("Failed to fetch recipe data");
    }

    const data = await response.json();
    return data.recipe;
  } catch (error) {
    console.error("Error fetching recipe:", error);
    throw error;
  }
};

export const fetchRecipeGemini = async (ingredients, cuisine, email, action = "full", recipeName = "", recipeText = "", preference = "No Preference") => {
  try {
    const response = await fetch(process.env.REACT_APP_SERVICE_URL + "recipe-ai-gemini", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ingredients: ingredients,
        cuisine: cuisine,
        email: email,
        action: action,
        recipe_name: recipeName,
        recipe_text: recipeText,
        preference: preference
      }),
    });

    if (!response.ok) {
      let errMessage = "Failed to fetch recipe data";
      try {
        const errData = await response.json();
        if (errData.error) errMessage = errData.error;
      } catch (e) {
        // ignore JSON parse error
      }
      throw new Error(errMessage);
    }

    const data = await response.json();
    return data; // Returns the full data, including recipe, image_url, etc.
  } catch (error) {
    console.error("Error fetching recipe:", error);
    throw error;
  }
};
// Image generation is now handled via the recipe-ai-gemini endpoint


export const uploadFileToS3 = async (imagename, file) => {
  imagename = process.env.REACT_APP_ENV + "-" + imagename;
  return new Promise((resolve, reject) => {
    const S3_BUCKET = process.env.REACT_APP_S3_BUCKET_NAME;
    const REGION = process.env.REACT_APP_S3_REGION;

    AWS.config.update({
      accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY.replace("RAMUK89", ""),
      secretAccessKey: process.env.REACT_APP_S3_SECRET_KEY.replace("ramuk89", ""),
    });

    const s3 = new AWS.S3({
      params: { Bucket: S3_BUCKET },
      region: REGION,
    });

    const params = {
      Bucket: S3_BUCKET,
      Key: imagename,
      Body: file,
      ACL: "public-read", // Make file publicly readable
    };

    s3.putObject(params)
      .promise()
      .then(() => {
        const url = `${process.env.REACT_APP_S3_BUCKET_URL}/${imagename}`;
        resolve(url);
      })
      .catch((err) => {
        console.error("Error uploading to S3:", err);
        reject(err);
      });
  });
};

export const imagetoCaption = async (imageUrl) => {
  try {
    const response = await fetch(process.env.REACT_APP_AI_SERVICE_URL + "image-to-caption", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        imageUrl: imageUrl,
      }),
    });

    // Check if the response is successful
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data.caption; // Assuming the response contains a "caption" field
  } catch (error) {
    console.error("Error fetching caption:", error.message);
    throw error;
  }
};
export const imagetoCaptionUsingOpenAI = async (imageUrl) => {
  try {
    const response = await fetch(process.env.REACT_APP_AI_SERVICE_URL + "image-to-caption-open-ai", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        image_url: imageUrl,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    const caption = data.choices?.[0]?.message?.content;
    return caption;
  } catch (error) {
    console.log("Error fetching caption:", error.message);
    throw error;
  }
};

export const analyzeFoodWithGemini = async (imageFile, email) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(imageFile);
    reader.onload = async () => {
      try {
        const base64Image = reader.result;
        const baseUrl = process.env.REACT_APP_SERVICE_URL.endsWith("/")
          ? process.env.REACT_APP_SERVICE_URL
          : process.env.REACT_APP_SERVICE_URL + "/";
        const response = await fetch(baseUrl + "recipe-ai-gemini", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            action: "analyze_food",
            image_data: base64Image,
            email: email,
          }),
        });

        if (!response.ok) {
          let errMsg = `HTTP error! Status: ${response.status}`;
          try {
            const errData = await response.json();
            if (errData.error) errMsg = errData.error;
          } catch (e) {
            // ignore JSON parse error
          }
          throw new Error(errMsg);
        }

        const data = await response.json();
        resolve(data.caption);
      } catch (error) {
        console.error("Error analyzing food with Gemini:", error);
        reject(error);
      }
    };
    reader.onerror = (error) => {
      console.error("Error reading file:", error);
      reject(error);
    };
  });
};

export const formatRecipe = (text) => {
  const lines = text && text.split("\n");
  return (
    lines &&
    lines.map((line, index) => {
      // Bold the recipe name by replacing ~name~ with <strong>name</strong>
      let formattedLine = line.replace(/~(.*?)~/g, (match, p1) => `<h5><strong>${p1.replace(/"/g, "").trim()}</strong></h5>`);

      // Bold text within ** by replacing **text** with <strong>text</strong>
      formattedLine = formattedLine.replace(/\*\*(.*?)\*\*/g, (match, p1) => `<strong>${p1}</strong>`);

      // Bold text starting with ###
      formattedLine = formattedLine.replace(/### (.*?)/g, (match, p1) => `<strong>${p1}</strong>`);

      if (line.startsWith("* ")) {
        // List items
        return (
          <div key={index} style={{ paddingLeft: '20px' }}>
            <small>
              <li className="text-small" dangerouslySetInnerHTML={{ __html: formattedLine.slice(2) }} />
            </small>
          </div>
        );
      } else if (/^\d+\.\s/.test(line)) {
        // Numbered list items
        return <p key={index} dangerouslySetInnerHTML={{ __html: formattedLine }} />;
      } else {
        // Regular text or headings
        return <p key={index} dangerouslySetInnerHTML={{ __html: formattedLine }} />;
      }
    })
  );
};

export const maskEmail = (email) => {
  if (!email) return "";
  const [name, domain] = email.split("@");
  if (!name || !domain) return email;
  if (name.length <= 2) {
    return `${name[0]}*****@${domain}`;
  }
  const first = name[0];
  const last = name[name.length - 1];
  const masked = "*".repeat(name.length - 2);
  return `${first}${masked}${last}@${domain}`;
};

export const fallbackParseVoice = (spokenText) => {
  if (!spokenText || typeof spokenText !== "string") {
    return { ingredients: [], recipeName: "", cuisine: "", preference: "No Preference", action: "full" };
  }

  const clean = spokenText
    .replace(/^i have\s+/i, "")
    .replace(/\s+in my fridge\b/gi, "")
    .replace(/\s+in my pantry\b/gi, "")
    .replace(/what can i make with\s+/gi, "")
    .replace(/make me a recipe with\s+/gi, "")
    .replace(/make me a\s+/gi, "make ")
    .replace(/make a\s+/gi, "make ");

  // Check if user specifically requested a named dish
  const makeMatch = clean.match(/make\s+([a-zA-Z\s]+)/i);
  let recipeName = "";
  if (makeMatch && makeMatch[1] && makeMatch[1].trim().length > 2) {
    recipeName = makeMatch[1].trim();
  }

  // Split ingredients by comma, 'and', 'plus', 'with'
  const rawParts = clean
    .replace(/make\s+[a-zA-Z\s]+/i, "")
    .split(/,|\band\b|\bwith\b|\bplus\b/);

  const ingredients = rawParts
    .map(p => p.trim().replace(/^[^\w]+|[^\w]+$/g, ""))
    .filter(p => p.length > 1 && !p.toLowerCase().startsWith("recipe") && !p.toLowerCase().startsWith("dish"));

  const action = ingredients.length > 0 ? "full" : (recipeName ? "recipe_by_name" : "full");

  return {
    ingredients,
    recipeName,
    cuisine: "Any",
    preference: "No Preference",
    action
  };
};

export const processVoiceWithGemini = async (spokenText) => {
  if (!spokenText || !spokenText.trim()) {
    return fallbackParseVoice("");
  }

  const apiKey =
    process.env.REACT_APP_GEMINI_API_KEY ||
    "AQ.Ab8RN6Lc9M2op8kpCkYFYFWoaQbQYoBtYBIcdbVpJIsMoWDa5w";

  const systemInstruction = `You are a culinary AI assistant. A user spoke this voice input for cooking:
"${spokenText}"

Extract ingredients, recipe name, cuisine, and dietary preference.
Return strictly valid JSON with this format:
{
  "ingredients": ["ingredient1", "ingredient2"],
  "recipeName": "specific dish name if mentioned or implied, otherwise empty string",
  "cuisine": "cuisine name if mentioned (e.g. Italian, Indian, Mexican, Chinese) or empty string",
  "preference": "Veg" or "Non-Veg" or "No Preference",
  "action": "full" or "recipe_by_name"
}`;

  const models = ["gemini-3.8-flash", "gemini-flash-latest", "gemini-2.5-flash-lite"];

  for (const model of models) {
    try {
      const response = await fetch(
        `https://generativelanguage.googleapis.com/v1beta/models/${model}:generateContent?key=${apiKey}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            contents: [{ parts: [{ text: systemInstruction }] }],
            generationConfig: {
              temperature: 0.1,
              responseMimeType: "application/json"
            }
          })
        }
      );

      if (!response.ok) {
        continue;
      }

      const data = await response.json();
      const text = data.candidates?.[0]?.content?.parts?.[0]?.text;
      if (text) {
        const cleaned = text.replace(/```json/gi, "").replace(/```/g, "").trim();
        const parsed = JSON.parse(cleaned);
        return {
          ingredients: Array.isArray(parsed.ingredients) ? parsed.ingredients : [],
          recipeName: parsed.recipeName || "",
          cuisine: parsed.cuisine || "",
          preference: parsed.preference || "No Preference",
          action: parsed.action || (parsed.ingredients?.length > 0 ? "full" : "recipe_by_name")
        };
      }
    } catch (err) {
      console.warn(`Voice processing error on model ${model}:`, err);
    }
  }

  // Graceful local fallback if Gemini is unreachable
  return fallbackParseVoice(spokenText);
};
